import { useState } from 'react';

import {
  Box,
  Flex,
  JaneGoldLogo,
  Link,
  PartnerLogo,
  Typography,
} from '@jane/shared/reefer';
import { sentenceCase } from '@jane/shared/util';

export interface SpecialDetailStatusHeaderProps {
  brandImage?: string;
  brandName?: string;
  specialDescription: string;
  specialTerms?: string;
  specialTitle: string;
  specialType: 'bundle' | 'product' | 'bulk';
}

export const SpecialDetailStatusHeader = ({
  brandImage,
  brandName,
  specialDescription,
  specialTitle,
  specialTerms,
  specialType,
}: SpecialDetailStatusHeaderProps) => {
  const [showTerms, setShowTerms] = useState(false);

  const isGold = !!brandName;
  const isBundle = specialType === 'bundle';

  return (
    <Box p={24}>
      {isGold && (
        <Flex justifyContent="space-between" pb={16}>
          {brandName && (
            <PartnerLogo
              name={brandName}
              image={brandImage}
              variant="brand"
              size="xs"
              data-testid="partner-logo"
            />
          )}

          <JaneGoldLogo data-testid="jane-gold-logo" height={26} />
        </Flex>
      )}

      <Typography as="span" color={isGold ? 'grays-mid' : 'info'}>
        {brandName && brandName}
        {brandName && isBundle && (
          <Typography mx={4} as="span" color="grays-mid">
            &#8226;
          </Typography>
        )}
        {((isGold && isBundle) || !isGold) && sentenceCase(specialType)}
      </Typography>

      <Typography branded variant="header-bold">
        {specialTitle}
      </Typography>

      <Typography>{specialDescription}</Typography>

      {specialTerms && (
        <Link color="grays-mid" onClick={() => setShowTerms((prev) => !prev)}>
          Terms and conditions
        </Link>
      )}

      {specialTerms && showTerms && (
        <Typography pt={16} color="grays-mid">
          {specialTerms}
        </Typography>
      )}
    </Box>
  );
};
